import { createFileRoute } from '@tanstack/react-router';
import { LogoLink } from '@/components/logo-link';
import { SignupForm } from './-components/signup-form';

export const Route = createFileRoute('/_auth/sign-up/')({
  component: SignUpComponent,
  head: () => ({
    meta: [{ title: 'FeatureBuddy - Sign Up' }],
  }),
});

function SignUpComponent() {
  return (
    <div className="flex flex-col gap-6">
      <LogoLink />
      <SignupForm />
      <div className="text-muted-foreground *:[a]:hover:text-primary text-center text-xs text-balance *:[a]:underline *:[a]:underline-offset-4">
        By clicking continue, you agree to our{' '}
        <a target="blank" href="https://featurebuddy.com/terms/">
          Terms of Service
        </a>{' '}
        and{' '}
        <a target="blank" href="https://featurebuddy.com/policy/">
          Privacy Policy
        </a>
        .
      </div>
    </div>
  );
}
